<!-- FILE: agent-status.component.html · KI-Agent-Statusanzeige (_40, 02.11.2026)
     Nur auf Projektseiten und nur, wenn der pslot Agenten hat und das Backend den Endpunkt kennt. -->
@if (st.available() && st.agents().length > 0) {

  <!-- [S1] Pille mit einem Punkt je Agent -->
  <button type="button" class="ag-pill" [class.ag-pill--warn]="st.worst() !== 'green' && st.waiting() > 0"
          data-testid="agents.pill" (click)="toggle()"
          [attr.aria-expanded]="open()" aria-label="AI agents in this project">
    <span class="ag-pill__label">AI</span>
    @for (a of st.agents(); track a.uuid) {
      <span class="ag-dot" [ngClass]="'ag-dot--' + a.light" [attr.data-testid]="'agents.dot-' + a.handle"
            [title]="a.display_name + ': ' + a.hint"></span>
    }
    @if (st.waiting() > 0) { <span class="ag-pill__count" data-testid="agents.waiting-count">{{ st.waiting() }}</span> }
  </button>

  <!-- [S2] Aufklappliste: wer, Zustand, was zu tun ist -->
  @if (open()) {
    <section class="ag-panel" data-testid="agents.panel" role="dialog" aria-label="AI agent status">
      <header class="ag-panel__head">
        <b>AI agents in this project</b>
        <button type="button" class="ag-panel__x" data-testid="agents.close" (click)="open.set(false)" aria-label="Close">×</button>
      </header>

      <ul class="ag-list">
        @for (a of st.agents(); track a.uuid) {
          <li class="ag-row" [attr.data-testid]="'agents.row-' + a.handle">
            <span class="ag-dot" [ngClass]="'ag-dot--' + a.light"></span>
            <div class="ag-row__body">
              <div><b>{{ a.display_name }}</b> <span class="ag-row__handle">&#64;{{ a.handle }}</span></div>
              <div class="ag-row__hint" [attr.data-testid]="'agents.hint-' + a.handle">{{ a.hint }}</div>
              <div class="ag-row__meta">
                Last seen {{ agoOf(a.last_seen_at) }}
                @if (a.open_requests > 0) {
                  · <b>{{ a.open_requests }} request{{ a.open_requests === 1 ? '' : 's' }} waiting</b>,
                  oldest {{ agoOf(a.oldest_request_at) }}
                }
              </div>
            </div>
          </li>
        }
      </ul>

      <!-- [S3] Kein Agent grün, aber Arbeit liegt an: deutlich sagen, was das heißt -->
      @if (st.worst() !== 'green' && st.waiting() > 0) {
        <p class="ag-panel__warn">
          Nobody is picking up requests right now. They stay in the queue and are answered
          once an agent is green.
        </p>
      }
      <button type="button" class="ag-panel__btn" data-testid="agents.waiting" (click)="showWaiting()">
        Show my open requests (Alt+P → Waiting for)
      </button>
    </section>
  }
}
